var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var TableHeadCell = function (_React$Component) {
  _inherits(TableHeadCell, _React$Component);

  function TableHeadCell() {
    _classCallCheck(this, TableHeadCell);

    return _possibleConstructorReturn(this, (TableHeadCell.__proto__ || Object.getPrototypeOf(TableHeadCell)).apply(this, arguments));
  }

  _createClass(TableHeadCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['className']);

      var _className = 'cf-table__cell cf-table__cell--head';

      if (className && className.trim()) {
        _className += ' ' + className.trim();
      }

      return React.createElement(
        'th',
        _extends({ className: _className }, props),
        this.props.children
      );
    }
  }]);

  return TableHeadCell;
}(React.Component);

TableHeadCell.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

TableHeadCell.defaultProps = {
  className: ''
};

export default TableHeadCell;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-table/es/TableHeadCell.js
// module id = 769
// module chunks = 0